import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-inline-diners',
    templateUrl: './inline-diners.component.html',
    styleUrl: './inline-diners.component.scss',
    standalone: false
})
export class InlineDinersComponent {
@Input() diners: any;
}
